function isIosDevice(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }

  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
}

/** Opens the device maps app with driving directions to `lat`, `lng` (WGS84). */
export function getExternalNavigationMapUrl(lat: number, lng: number): string {
  if (isIosDevice()) {
    return `https://maps.apple.com/?daddr=${lat},${lng}&dirflg=d`;
  }

  return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
}
